import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { firstValueFrom } from 'rxjs';
import { AppConfigService } from '../app-config.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  constructor(
    private authService: MsalService,
    private appConfigService: AppConfigService
  ) {}

  async getMicrosoftAccessToken(): Promise<string> {
    let scopes = this.appConfigService.config?.protectedResources?.scopes?.map(scope => scope) || [];
    try {
      const result = await firstValueFrom(this.authService.acquireTokenSilent({
        scopes: scopes,
        redirectUri: this.appConfigService.config?.msal?.auth?.silentRedirectUri,
        account: this.authService.instance.getActiveAccount()!
      }));
      return result.accessToken;
    } catch (silentError) {
      console.warn('Silent token acquisition failed, falling back to popup', silentError);
      try {
        // Use window.location.origin to ensure popup closes and returns to main app after authentication
        const result = await firstValueFrom(this.authService.acquireTokenPopup({
          scopes: scopes,
          redirectUri: this.appConfigService.config?.msal?.auth?.redirectUri
        }));
        const accounts = this.authService.instance.getAllAccounts();
        if (accounts.length > 0) {
          this.authService.instance.setActiveAccount(accounts[0]);
        }
        return result.accessToken;
      } catch (popupError) {
        console.error('Error acquiring token with popup', popupError);
      }
    }
    return "";
  }
}
